<template>
  <div class="ResumoImagens">
    <FormAddDocs v-if="allowAdd"
                 :perfil="tipoRegistro"
                 :registro-id="registroId"
                 @uploadDone="uploaded" />
    <NoResults v-if="!imagens.length && !addBox" />
    <div
      class="ResumoImagens-container mt-3">
      <ImageBox
        :registro-id="registroId"
        :type-profile="tipoRegistro"
        :image-list="imagens"
        @removed="removeImage" />
    </div>
  </div>
</template>

<script>
	/* assets */
  import plus from "@/assets/icons/add.svg?sprite"
  import image from "@/assets/icons/ICONS/ICONS/file-image.svg?sprite"

  /* components */
  import NoResults from "@/components/SofiaRei/Resumo/NoResults"
  import FormAddDocs from "@/components/SofiaRei/Busca/FormAddDocs"
  import ImageBox from "@/components/SofiaRei/Busca/ImageBox"

  /* helpers */
  import PerfilRegistroHelper from "@/helpers/Registros/PerfilRegistroHelper"

  export default {
    name: "ResumoImagens",
    components: { NoResults, FormAddDocs, ImageBox },
    props: {
      registroId: { type: Number, required: true },
      tipoRegistro: { type: String, required: true },
      propImagens: { type: Array, default: () => []},
      allowAdd: { type: Boolean, default: true }
    },

    data () {
      return {
        icons: { plus, image },
        settings: { tiposImagens: [] },
        addBox: false,
        imagem: { tipo: "", file: ""},
        imagens: []
      }
    },

    watch: {
      propImagens () {
        this.imagens = this.propImagens
      }
    },

    async mounted () {
      this.imagens = this.propImagens
      this.settings.tiposImagens = await PerfilRegistroHelper.getPerfilGED(this.tipoRegistro)
    },

    methods: {
      async uploaded (imagemUploaded) {
        this.imagens.push(imagemUploaded)

        this.$emit('updateData')

        objSwal.success.title = 'Imagem Cadastrada com Sucesso!'
        objSwal.success.text = ''
        objSwal.success.html = ''

        await Swal.fire(objSwal.success)

        this.setFocus()
      },

      async removeImage (index) {
        this.imagens.splice(index, 1)

        this.$emit('updateData')

        objSwal.success.title = 'Imagem Removida com Sucesso!'
        objSwal.success.text = ''
        objSwal.success.html = ''

        await Swal.fire(objSwal.success)

        this.setFocus()
      },

      async setFocus () {
        setTimeout(() => {
          const addImg = document.getElementById('add_img')

          if (addImg) addImg.focus()
        }, 300)
      }
    }
  }
</script>

<style lang="scss">
@import "../../../scss/_utilities/exports";

.ResumoImagens {
	&-show {
		&_title {
			background-color: $sinoreg-blue;
			color: $color-white;
			font-size: pxToRem(22);
			font-weight: 500;
			padding: pxToRem(8);
		}

		&_title-label {
			font-size: pxToRem(22);
			font-weight: 500;
		}

		&_icon {
			fill: $color-white;
		}

		&_label {
			font-size: pxToRem(14);
		}

		&_sublabel {
			font-size: pxToRem(14);
			font-weight: 600;
		}

		&_header{
			&--grey{
				background-color: $sinoreg-card-gray;
				cursor: pointer;
				padding: pxToRem(10) pxToRem(20);
				color: $color-black;
				font-weight: 500;
				font-size: pxToRem(16);
			}

			&--blue{
				background-color: $color-light-blue;
				padding: pxToRem(10) pxToRem(20);
				color: $color-black;
				font-weight: 500;
				font-size: pxToRem(16);
			}

			&--shadow{
				box-shadow: 1px 2px pxToRem(7) $color-gray;
			}

			&--label{
				text-decoration: underline;
				font-size: pxToRem(13);
				margin-bottom: 0;
			}

			&--sublabel{
				font-size: pxToRem(13);
			}
		}

		&_vinculacao-header{
			font-size: pxToRem(12);
		}

		&_vinculacao-divider{
			border-top: 1px solid black;
		}

		&_hr{
			border-top: 1px solid $sinoreg-blue;
		}
	}
	&-addBox {
		&__title {
			background-color: black;
			color: white;
		}
		&__content {
			padding: 10px;
		}
	}
	&-container{
		min-height: 250px
	}
	&.collapsed > .when-opened,
	:not(.collapsed) > .when-closed {
		display: none;
	}

	&.icons {
		&--black{
			fill: black;
		}
	}
}

</style>
